import {useCallback} from 'react';

import {CO_PARENT_EVENTS} from '@/app/auth/events/CoParentEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewCoParentingLinkOpen = useCallback(() => {
    trackEvent(CO_PARENT_EVENTS.VIEW_CO_PARENTING_LINK_OPEN, {
      project_tag: PROJECT_TAGS.CO_PARENT,
    });
  }, [trackEvent]);

  const trackSelectCoParentingAcceptInvite = useCallback(() => {
    trackEvent(CO_PARENT_EVENTS.SELECT_CO_PARENTING_ACCEPT_INVITE, {
      project_tag: PROJECT_TAGS.CO_PARENT,
    });
  }, [trackEvent]);

  return {
    trackViewCoParentingLinkOpen,
    trackSelectCoParentingAcceptInvite,
  };
};
